import border from '../../border';

const dark = (params) => border.hover.dark(params);

export default dark;
